import { FC, useState } from "react";
import { Box, Image } from "../../../styles/basicStyles";
import { ArticleWrapper, CategoryWrapper } from "./styles";
import { useRouter } from "next/router";
import { ImageWrapper } from "../../../components/views/card/styles";
import Typography from "../../../components/typography";
import VisibilitySensor from "react-visibility-sensor";
import Fade from "react-reveal/Fade";
import useLazyBgImage from "../../../hooks/images/useLazyBgImage";

interface ArticleProps {
  image: string;
  category: string;
  title: string;
  url: string;
  setLoading: (value: boolean) => void;
}

const Article: FC<ArticleProps> = ({ image, category, title, url, setLoading }) => {
  const router = useRouter();
  const [started, setStarted] = useState<boolean>(false);
  const bgRef = useLazyBgImage([image]);
  
  const checkState = (isVisible: boolean) => {
    if(isVisible && !started) setStarted(true);
  };

  return (
    <VisibilitySensor onChange={checkState} partialVisibility delayedCall>
      <ArticleWrapper
        fDirection="column"
        padding={{ xs: "1.156rem 1.156rem", xxs: "1.156rem 0" }}
        w={{ md: "33.333%", xs: "50%", xxs: "100%" }}
        onClick={() => { setLoading(true); router.push(url); }}
      >
        <ImageWrapper ref={(el) => (bgRef.current[0] = el)} started={started} className="image">
          <Image src='/assets/fill_blog.gif' w='100%' h='auto' alt='related post image' />
        </ImageWrapper>
        <Fade bottom cascade>
          <Box fDirection='column'>
            <CategoryWrapper mt={0.875} mb={0.5}>
              <Typography fSize={0.938} lHeight={1.125} fWeight={600}>
                {category}
              </Typography>
            </CategoryWrapper>
            <Typography
              fSize={{ md: 1.25, xxs: 1 }}
              lHeight={{ md: 1.875, xxs: 1.5 }}
              fWeight={700}
            >
              {title}
            </Typography>
          </Box>
        </Fade>
      </ArticleWrapper>
    </VisibilitySensor>
  );
};

export default Article;
